module.exports = __webpack_public_path__ + "static/media/add.f2682ff7.svg";